export default "__VITE_ASSET__C7lCu53P__"